import routerOptions0 from "/vercel/path1/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@14.18.33_@vue+compiler-sfc@3.5.22_db0@0.3.4_ior_ydkou6zpxanmnc6dgeqk2ysra4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}